import React, { useState, useEffect } from 'react';
import { Card, Form, Input, Button, Descriptions, message } from 'antd';
import { SaveOutlined } from '@ant-design/icons';
import { getMacRule, saveMacRule } from '../../api/config';
import { hasPerm } from '../../hooks/usePermission';

const MacRuleConfig = () => {
    const [form] = Form.useForm();
    const [loading, setLoading] = useState(false);
    const [saving, setSaving] = useState(false);
    const [used, setUsed] = useState(0);
    const [capacity, setCapacity] = useState(0);

    const fetchRule = async () => {
        setLoading(true);
        try {
            const res = await getMacRule();
            if (res.code === 0) {
                const { prefix, start, end, current } = res.data;
                form.setFieldsValue({ prefix, start, end });
                setUsed(current);
                setCapacity(parseInt(end, 16) - parseInt(start, 16) + 1);
            } else {
                message.error(res.message || '获取规则失败');
            }
        } catch (error) {
            console.error('Fetch mac rule failed:', error);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchRule();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const handleSave = async () => {
        const values = await form.validateFields();
        setSaving(true);
        try {
            const res = await saveMacRule(values);
            if (res.code === 0) {
                message.success('MAC 规则保存成功');
            } else {
                message.error(res.message || '保存失败');
            }
        } catch (error) {
            if (error.errorFields) return;
            console.error('Save mac rule failed:', error);
        } finally {
            setSaving(false);
        }
    };

    return (
        <div style={{ padding: '16px' }}>
            <Card title="MAC 地址生成规则" loading={loading} style={{ maxWidth: 560 }}>
                <Form form={form} layout="vertical">
                    <Form.Item name="prefix" label="MAC 前缀（固定）" rules={[{ required: true, message: '请输入 MAC 前缀' }]}>
                        <Input placeholder="如 E0DCA0" />
                    </Form.Item>
                    <Form.Item name="start" label="后缀起始值" rules={[{ required: true, message: '请输入起始值' }]}>
                        <Input placeholder="如 09B8AB" />
                    </Form.Item>
                    <Form.Item name="end" label="后缀截止值" rules={[{ required: true, message: '请输入截止值' }]}>
                        <Input placeholder="如 0A0000" />
                    </Form.Item>
                    <Form.Item>
                        {hasPerm('config:mac-rule:save') && (
                            <Button type="primary" icon={<SaveOutlined />} loading={saving} onClick={handleSave}>保存规则</Button>
                        )}
                    </Form.Item>
                </Form>
            </Card>

            <Card title="使用情况" style={{ maxWidth: 560, marginTop: 16 }}>
                <Descriptions column={1}>
                    <Descriptions.Item label="当前已分配 MAC 数量">{used}</Descriptions.Item>
                    <Descriptions.Item label="可生成 MAC 数量">{capacity}</Descriptions.Item>
                    <Descriptions.Item label="规则说明">前缀固定 + 后缀自增，通过「后缀起始值」与「后缀截止值」锁定可生成范围，导入串码时自动补全唯一 MAC 地址</Descriptions.Item>
                </Descriptions>
            </Card>
        </div>
    );
};

export default MacRuleConfig;
